import { toast } from 'react-hot-toast'

export const openInNewTab = (url: string) => {
  const newWindow = window.open(url, '_blank')
  if (newWindow) {
    newWindow.opener = null
  } else {
    toast.error(
      'Failed to open link in new tab. Please allow pop-ups in your browser settings.'
    )
  }
}
